const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Add+Samples+to+Basket+API

function addSamplesToBasket(sampleSkuIdList) {
    const url = '/api/shopping-cart/basket/samples';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ sampleSkuIdList })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = addSamplesToBasket;
